export default __webpack_public_path__ + "static/media/fastlearner.2d63c34c.svg";